import bootstrap from './bootstrap'; // Load plugins needed here

(function($) {

    'use strict';

   

    class Tichy {
        constructor(properties) {
            this.properties = properties;
        }

        dropDownHack() {
            let dropDownAbout = $('.menu-item.dropdown');
            let clickLayer = $('<div></div>').addClass('dropdownHack');

            dropDownAbout.append(clickLayer);

            // console.log(dropDownAbout.find('a').text());
            clickLayer.on('click',function(e){
                e.preventDefault();
                console.log('Hello');
                // if(dropDownAbout.text() == 'About'){
                    location.href="/about";
                // }

            });
        }

        sliderHome(){
            var bgImg = $('.hero-text').parents('.sa_hover_container').css('background-image');
            $('.hero-text').css('background-image',bgImg);
            $('.hero-text').parents('.sa_hover_container').css('background-image','');
        }
    }

    var tichy = new Tichy;
    tichy.dropDownHack();
    tichy.sliderHome();

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/main.js